import { composeIO } from 'react-compose-io'
import { popoverFiltroPedidoMktIO } from './PopoverFiltroPedidoMkt.IO'
import { PopoverFiltroPedidoMktView } from './PopoverFiltroPedidoMkt.View'

export const PopoverFiltroPedidoMkt = composeIO(PopoverFiltroPedidoMktView, popoverFiltroPedidoMktIO)
